export const NOTIFICATIONS_POLLING_INTERVAL = 30000; // 30 seconds
